/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreAccount } from '../models/RestoreAccount';

export class ConnectRestoreAccountResponse {
  'restoreAccount': RestoreAccount;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccount",
      "baseName": "restoreAccount",
      "type": "RestoreAccount",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectRestoreAccountResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

